function formatDate(value) {
  return value.replace(/-/g, '.')
}

export default formatDate